const CardModule = {
    namespaced: true,
    state: () => ({
        show: false,
        callback: ()=>{}
    }),
    getters: {
        getShow(state) {
            return state.show
        },
        getCallback(state) {
            return state.callback
        },
    },
    mutations: {
        setShow(state, payload) {
            state.show = payload
        },
        setCallback(state, payload) {
            state.callback = payload
        },
    },
    actions: {
        setShow(context, payload) {
            context.commit('setShow', payload);
        },
        setCallback(context, payload) {
            context.commit('setCallback', payload);
        },
    },
}

export default CardModule;
